<template>
  <div id="form" class="container">
    <header id="logo" class="d-none">
      <img
        src="../assets/logo.png"
        width="205"
        alt="Accueil aménager mon jardin avec Quicklam et Leroy Merlin"
      />
    </header>
    <div id="intro" class="row">
      <div class="col">
        <img
          :src="'../static/' + type + '.jpg'"
          :alt="type"
          class="img-fluid"
        />
      </div>
      <div class="col">
        <h1>{{ descriptions[type].title }}</h1>
        <p v-html="descriptions[type].text"></p>
      </div>
    </div>
    <div id="specs" class="d-none">
      <ul>
        <li>
          Type de palissade : <b>{{ type }}</b>
        </li>
        <li>
          Longueur totale : <b>{{ length }}m</b>
        </li>
        <li>
          Hauteur : <b>{{ height }}cm</b>
        </li>
        <li>
          Nombre d'angles : <b>{{ angle }}</b>
        </li>
        <li>
          Longueur de lame : <b>{{ pLength }}cm</b>
        </li>
      </ul>
    </div>
    <form @submit.prevent="submitForm">
      <fieldset>
        <div class="row">
          <div class="col">
            <div
              class="form-group"
              :class="{ input: true, 'has-error': errors.has('length') }"
            >
              <label for="length"
                >Longueur totale en m <span class="required">*</span></label
              >
              <input
                type="number"
                id="length"
                name="length"
                min="1"
                max="1000"
                step="0.5"
                v-model="length"
                v-validate="'required'"
                class="form-control"
                placeholder="Longueur"
              />
            </div>
          </div>
          <div class="col">
            <div
              class="form-group"
              :class="{ input: true, 'has-error': errors.has('height') }"
            >
              <label for="height"
                >Hauteur en cm <span class="required">*</span></label
              >
              <input
                type="number"
                id="height"
                name="height"
                min="50"
                max="200"
                step="0.5"
                v-model="height"
                v-validate="'required'"
                class="form-control"
                placeholder="Hauteur"
              />
            </div>
          </div>
          <div v-if="hasAngles" class="col">
            <div class="form-group">
              <label for="angles">Nombre d'angles</label>
              <select
                name="angles"
                id="angles"
                class="form-control"
                v-model="angle"
                v-validate="'required'"
              >
                <option value="0">0</option>
                <option v-for="i in 10" v-bind:key="i">{{ i }}</option>
              </select>
            </div>
          </div>
          <div v-if="hasPlenght" class="col">
            <div class="form-group">
              <label for="pLength">Longueur de lame</label>
              <select
                name="pLength"
                id="pLength"
                class="form-control"
                v-model="pLength"
                v-validate="'required'"
              >
                <option value="180">180 cm</option>
                <option value="240" selected>240 cm</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <a href="/" class="btn btn-outline-dark">Retour</a>
              <button type="submit" class="btn btn-primary">Calculer</button>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
    <div v-show="showResult" class="result">
      <table class="table table-bordered">
        <thead class="thead-light">
          <tr>
            <th></th>
            <th>Produit</th>
            <th>Quantité</th>
          </tr>
        </thead>
        <tbody v-for="(v, k) in products[type]" v-bind:key="k">
          <tr>
            <td colspan="4" class="headline">{{ k }}</td>
          </tr>
          <tr v-for="(j, i) in v" v-bind:key="i" v-show="j.qty > 0">
            <td class="image">
              <img :src="'../static/' + j.ref + '.jpg'" :alt="j.ref" />
            </td>
            <td>
              <b>{{ j.designation }}</b> <br /><i>Ref LM : {{ j.ref }}</i>
            </td>
            <td>{{ j.qty }}</td>
          </tr>
        </tbody>
      </table>
      <div id="print">
        <button class="btn btn-dark" onclick="window.print();">
          Imprimer mon devis
        </button>
        <a
          :href="descriptions[type].url"
          target="_blank"
          style="text-align: center; margin: 30px auto; display: block; color: #5ead0f; text-decoration: underline;"
          >Retrouvez ces produits sur le site Leroy Merlin</a
        >
      </div>
    </div>
    <p id="ml" class="d-none">
      Devis réalisé sur le site
      <a href="http://www.amenager-mon-jardin.com/"
        >www.amenager-mon-jardin.com</a
      >
    </p>
  </div>
</template>

<script>
import Vue from "vue";
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);

export default {
  name: "Form",
  data() {
    return {
      type: this.$route.params.slug,
      height: null,
      length: null,
      angle: 0,
      pLength: 240,
      showResult: false,
      descriptions: {
        "quick-lam-classic": {
          title: "Quick'Lam classique",
          text:
            "La palissade Quick-Lam classique est un ensemble modulable composée de demi-poteau rainuré à assembler, de lames standards à volet et de lames de finition. Les poteaux sont en pin traité classe 4. Les lames sont en sapin-épicéa de haute qualité, traité classe 3 en autoclave. La couleur claire argenté avec de petits nœuds adhérents sont discrets et prennent une teinte grise argentée dans le temps.",
          url:
            "https://www.leroymerlin.fr/v3/p/produits/cloture-a-composer-bois-quick-lam-e1500266386"
        },
        "quick-lam-twin": {
          title: "Quick'Lam Twin",
          text:
            "La palissade Quick’Lam évolue avec la lame TWIN plus contemporaine qui présente un faux-claire-voie. Cette lame en sapin-épicéa traité en autoclave Classe 3 de Scandinavie est une alternative à la lame à volet classique standard. Le concept de demi-poteaux bois proposé pour une installation modulable est identique à la palissade Quick’Lam Standard",
          url:
            "https://www.leroymerlin.fr/v3/search/search.do?resultOffset=0&resultLimit=50&resultListShape=PLAIN&keyword=quicklam"
        },
        "quick-lam-metal": {
          title: "Quick'Lam métal",
          text:
            "La palissade Quick-Lam avec des poteaux en acier galvanisé laqués époxy gris anthracite (RAL 7016) permet de renforcer la structure et donner une touche plus contemporaine à votre clôture. Les poteaux de section 7x7cm ont une épaisseur de 1,5mm de métal, ils peuvent être à sceller ou bien livré avec une platine soudée pour une fixation sur dalle béton. Tous les poteaux sont équipés de chapeaux en plastique.",
          url:
            "https://www.leroymerlin.fr/v3/p/produits/cloture-a-composer-bois-quick-lam-e1500266386"
        },
        "quick-lam-twin-metal": {
          title: "Quick'Lam Twin métal",
          text:
            "Les poteaux métalliques de Quick’Lam, combinés avec les nouvelles lames à faux-claire voie TWIN sont résolument contemporaines et renforcent la rigidité de la palissade. Les poteaux métalliques en acier galvanisé de 1,5mm d’épaisseur ont une rainure de 28mm pour recevoir les lames à volet standards ou lames TWIN. Faite le choix de la modernité et de la durabilité.",
          url:
            "https://www.leroymerlin.fr/v3/search/search.do?resultOffset=0&resultLimit=50&resultListShape=PLAIN&keyword=quicklam"
        },
        "quick-lam-venezia": {
          title: "Quick'Lam Vénézia",
          text:
            "La clôture Quick’Lam Venézia combine lames occultantes standards et des lamelles pour une touche moderne dans votre jardin. Un décor de 4 lamelles persiennées pour jouer avec les lumières et donner du relief à votre palissade. Le kit Venezia est composé de 4 rails et de supports de lames en fonte d’aluminium pour équiper les demi-poteaux rainurés qui s’orientent selon 2 angles au choix.",
          url:
            "https://www.leroymerlin.fr/v3/p/produits/cloture-a-composer-bois-quick-lam-mixte-e1500647906"
        },
        "quick-lam-double": {
          title: "Quick'Lam quinconce",
          text:
            "Réalisez votre propre palissade occultante avec des lamelles Venezia en quinconce à la hauteur que vous désirez. Les poteaux double rainures Quick’Lam permettent d’insérer les lames Venezia en les décalant chacune de 10 cm en hauteur.  Au final, un raidisseur s’intercale au milieu de votre palissade pour assurer une parfaite rigidité",
          url:
            "https://www.leroymerlin.fr/v3/search/search.do?resultOffset=0&resultLimit=50&resultListShape=PLAIN&keyword=quicklam"
        }
      },
      products: {
        "quick-lam-classic": {
          remplissage: {
            lame: {
              ref: "68192474",
              designation: "Lame clôture QUICK sapin traité 2.8x13.5x240 cm",
              image: "",
              qty: 0
            },
            lameFinition: {
              ref: "68192460",
              designation: "Lame finition QUICK sapin traité 2.8x14.5x240 cm",
              image: "",
              qty: 0
            }
          },
          structure: {
            poteau: {
              ref: "82001893",
              designation: "POTEAU RAINURE EN H QUICK 9X9X240CM CL4 – 0961",
              image: "",
              qty: 0
            },
            poteau_l: {
              ref: "68192481",
              designation: "POTEAU RAINURE EN L QUICK 9X9X240CM CL4 –0962",
              image: "",
              qty: 0
            },
            chapeau: {
              ref: "70573573",
              designation: "4 chapeaux laqués époxy noir pour poteau 9x9 cm",
              image: "",
              qty: 0
            },
            poteau_d_f: {
              ref: "82001894",
              designation: "POTEAU EN U QUICK 9X9X240CM CL4",
              image: "",
              qty: 0
            }
          }
        },
        "quick-lam-twin": {
          remplissage: {
            lame: {
              ref: "80027906",
              designation: "Lame twin quick'lam 2.8x13.5x240 cm",
              image: "",
              qty: 0
            }
          },
          structure: {
            poteau: {
              ref: "82001893",
              designation: "POTEAU RAINURE EN H QUICK 9X9X240CM CL4 – 0961",
              image: "",
              qty: 0
            },
            poteau_l: {
              ref: "68192481",
              designation: "POTEAU RAINURE EN L QUICK 9X9X240CM CL4 –0962",
              image: "",
              qty: 0
            },
            chapeau: {
              ref: "70573573",
              designation: "4 chapeaux laqués époxy noir pour poteau 9x9 cm",
              image: "",
              qty: 0
            },
            poteau_d_f: {
              ref: "82001894",
              designation: "POTEAU EN U QUICK 9X9X240CM CL4",
              image: "",
              qty: 0
            }
          }
        },
        "quick-lam-metal": {
          remplissage: {
            lame: {
              ref: "68192474",
              designation: "Lame clôture QUICK sapin traité 2.8x13.5x240 cm",
              image: "",
              qty: 0
            },
            lameFinition: {
              ref: "68192460",
              designation: "Lame finition QUICK sapin traité 2.8x14.5x240 cm",
              image: "",
              qty: 0
            }
          },
          structure: {
            poteau: {
              ref: "",
              designation: "Poteau aluminium",
              image: "",
              qty: 0
            }
          }
        },
        "quick-lam-twin-metal": {
          remplissage: {
            lame: {
              ref: "80027906",
              designation: "Lame twin quick'lam 2.8x13.5x240 cm",
              image: "",
              qty: 0
            }
          },
          structure: {
            poteau: {
              ref: "",
              designation: "Poteau aluminium",
              image: "",
              qty: 0
            },
            poteau_d_f: {
              ref: "82001894",
              designation: "POTEAU EN U QUICK 9X9X240CM CL4",
              image: "",
              qty: 0
            }
          }
        },
        "quick-lam-venezia": {
          remplissage: {
            lame: {
              ref: "68192474",
              designation: "Lame clôture QUICK sapin traité 2.8x13.5x240 cm",
              image: "",
              qty: 0
            },
            lameVenezia: {
              ref: "69127520",
              designation: "Lame cloture venezia",
              image: "",
              qty: 0
            }
          },
          structure: {
            poteau: {
              ref: "82001893",
              designation: "POTEAU RAINURE EN H QUICK 9X9X240CM CL4 – 0961",
              image: "",
              qty: 0
            },
            poteau_l: {
              ref: "68192481",
              designation: "POTEAU RAINURE EN L QUICK 9X9X240CM CL4 –0962",
              image: "",
              qty: 0
            },
            chapeau: {
              ref: "70573573",
              designation: "4 chapeaux laqués époxy noir pour poteau 9x9 cm",
              image: "",
              qty: 0
            },
            kit: {
              ref: "69127534",
              designation: "Kit de fixation venezia (8 lames) quick",
              image: "",
              qty: 0
            },
            poteau_d_f: {
              ref: "82001894",
              designation: "POTEAU EN U QUICK 9X9X240CM CL4",
              image: "",
              qty: 0
            }
          }
        },
        "quick-lam-double": {
          remplissage: {
            lameVenezia: {
              ref: "69127520",
              designation: "Lame cloture venezia",
              image: "",
              qty: 0
            }
          },
          structure: {
            poteau: {
              ref: "80027913",
              designation: "1/2 poteau quick'lam 2,4m double rainure",
              image: "",
              qty: 0
            },
            raidisseur: {
              ref: "80027934",
              designation: "Raidisseur quick'lam 15x45mm x 1,8m",
              image: "",
              qty: 0
            },
            chapeau: {
              ref: "70573573",
              designation: "4 chapeaux laqués époxy noir pour poteau 9x9 cm",
              image: "",
              qty: 0
            },
            poteau_d_f: {
              ref: "82001894",
              designation: "POTEAU EN U QUICK 9X9X240CM CL4",
              image: "",
              qty: 0
            }
          }
        }
      }
    };
  },
  computed: {
    hasAngles() {
      return ["quick-lam-metal", "quick-lam-twin-metal"].indexOf(this.type) < 0;
    },
    hasPlenght() {
      return ["quick-lam-classic", "quick-lam-metal"].indexOf(this.type) > -1;
    }
  },
  methods: {
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this[this.camelize(this.type)]();
          this.showResult = true;
          return false;
        }
      });
    },
    quickLamClassic() {
      this.products[this.type].structure.poteau.qty =
        Math.ceil((this.length * 100) / this.pLength) - parseInt(this.angle);
      if (parseInt(this.angle) > 0) {
        this.products[this.type].structure.poteau_l.qty = parseInt(this.angle);
      } else {
        this.products[this.type].structure.poteau_l.qty = 0;
      }
      this.products[this.type].structure.chapeau.qty = Math.ceil(
        this.products[this.type].structure.poteau.qty / 4
      );
      this.products[this.type].remplissage.lameFinition.qty = Math.ceil(
        (this.length * 100) / this.pLength
      );
      this.products[this.type].remplissage.lame.qty =
        Math.ceil((this.length * 100) / this.pLength) *
          Math.ceil(this.height / 13.5) -
        this.products[this.type].remplissage.lameFinition.qty;
      this.products[this.type].remplissage.lame.ref =
        parseInt(this.pLength) === 180 ? "69127464" : "68192474";
      this.products[this.type].remplissage.lame.designation =
        parseInt(this.pLength) === 180
          ? "Lame cloture sapin 2.8x14.5x180 cm"
          : "Lame clôture QUICK sapin traité 2.8x13.5x240 cm";
      this.products[this.type].structure.poteau_d_f.qty = 2;
    },
    quickLamTwin() {
      this.products[this.type].structure.poteau.qty =
        Math.ceil((this.length * 100) / this.pLength) * 2 -
        parseInt(this.angle);
      if (parseInt(this.angle) > 0) {
        this.products[this.type].structure.poteau_l.qty = parseInt(this.angle);
      } else {
        this.products[this.type].structure.poteau_l.qty = 0;
      }
      this.products[this.type].remplissage.lame.qty =
        Math.ceil((this.length * 100) / this.pLength) *
        Math.ceil(this.height / 13.5);
      this.products[this.type].structure.chapeau.qty = Math.ceil(
        this.products[this.type].structure.poteau.qty / 4
      );
      this.products[this.type].structure.poteau_d_f.qty = 2;
    },
    quickLamMetal() {
      if (this.height < 100) {
        this.products[this.type].structure.poteau.ref = "80027941";
        this.products[this.type].structure.poteau.designation =
          "Poteau 7x7x100cm acier galvanisé laqué époxy RAL 7016";
      } else if (this.height >= 100 && this.height < 180) {
        this.products[this.type].structure.poteau.ref = "80027955";
        this.products[this.type].structure.poteau.designation =
          "Poteau 7x7x180cm acier galvanisé laqué époxy RAL 7016";
      } else if (this.height >= 180) {
        this.products[this.type].structure.poteau.ref = "80027962";
        this.products[this.type].structure.poteau.designation =
          "Poteau 7x7x230cm acier galvanisé laqué époxy RAL 7016 - à sceller";
      }
      this.products[this.type].structure.poteau.qty = Math.ceil(
        (this.length * 100) / this.pLength
      );
      this.products[this.type].remplissage.lameFinition.qty = Math.ceil(
        (this.length * 100) / this.pLength
      );
      this.products[this.type].remplissage.lame.qty =
        Math.ceil((this.length * 100) / this.pLength) *
          Math.ceil(this.height / 13.5) -
        this.products[this.type].remplissage.lameFinition.qty;
    },
    quickLamTwinMetal() {
      if (this.height < 100) {
        this.products[this.type].structure.poteau.ref = "80027941";
        this.products[this.type].structure.poteau.designation =
          "Poteau 7x7x100cm acier galvanisé laqué époxy RAL 7016";
      } else if (this.height >= 100 && this.height < 180) {
        this.products[this.type].structure.poteau.ref = "80027955";
        this.products[this.type].structure.poteau.designation =
          "Poteau 7x7x180cm acier galvanisé laqué époxy RAL 7016";
      } else if (this.height >= 180) {
        this.products[this.type].structure.poteau.ref = "80027962";
        this.products[this.type].structure.poteau.designation =
          "Poteau 7x7x230cm acier galvanisé laqué époxy RAL 7016 - à sceller";
      }
      this.products[this.type].structure.poteau.qty = Math.ceil(
        (this.length * 100) / this.pLength
      );
      this.products[this.type].remplissage.lame.qty =
        Math.ceil((this.length * 100) / this.pLength) *
        Math.ceil(this.height / 13.5);
    },
    quickLamVenezia() {
      this.products[this.type].remplissage.lame.qty =
        Math.ceil((this.length * 100) / this.pLength) *
        Math.ceil((this.pLength - 45) / 13.5);
      this.products[this.type].structure.poteau.qty =
        Math.ceil((this.length * 100) / this.pLength) * 2 -
        parseInt(this.angle);
      if (parseInt(this.angle) > 0) {
        this.products[this.type].structure.poteau_l.qty = parseInt(this.angle);
      } else {
        this.products[this.type].structure.poteau_l.qty = 0;
      }
      this.products[this.type].structure.chapeau.qty = Math.ceil(
        this.products[this.type].structure.poteau.qty / 4
      );
      this.products[this.type].remplissage.lameVenezia.qty =
        Math.ceil((this.length * 100) / this.pLength) * 4;
      this.products[this.type].structure.kit.qty = Math.ceil(
        (this.length * 100) / this.pLength / 2
      );
      this.products[this.type].structure.poteau_d_f.qty = 2;
    },
    quickLamDouble() {
      this.products[this.type].remplissage.lameVenezia.qty =
        Math.ceil((this.length * 100) / this.pLength) *
        Math.ceil(this.height / 11);
      this.products[this.type].structure.poteau.qty =
        Math.ceil((this.length * 100) / this.pLength) * 2 +
        parseInt(this.angle);
      this.products[this.type].structure.chapeau.qty = Math.ceil(
        this.products[this.type].structure.poteau.qty / 8
      );
      this.products[this.type].structure.raidisseur.qty =
        Math.ceil((this.length * 100) / this.pLength) *
        Math.ceil(this.height / 11 - 2);
      this.products[this.type].structure.poteau_d_f.qty = 2;
    },
    camelize(str) {
      return str.replace(/\W+(.)/g, function(match, chr) {
        return chr.toUpperCase();
      });
    }
  },
  mounted() {}
};
</script>

<style type="text/css">
#intro {
  margin-bottom: 30px;
}
h1 {
  text-transform: uppercase;
  color: #5ead0f;
  font-size: 32px;
  border-left: 4px solid #5ead0f;
  padding-left: 15px;
  line-height: 37px;
  font-weight: bold;
  margin-bottom: 15px;
}
.form-group.has-error input[type="number"] {
  border-color: #dc3545;
}
.table td.headline {
  background-color: lightgray;
  text-transform: uppercase;
  font-size: 11px;
}
.table .thead-light th {
  color: #ffffff;
  background-color: #5ead0f;
  border-color: #5dad0f;
}
.table td,
.table td {
  vertical-align: middle;
}
.table tr td.image {
  padding: 0;
}
.table tr td.image img {
  margin: 5px auto;
  display: block;
}
.table tr td i {
  color: #838383;
  font-style: initial;
  font-size: 12px;
}
.btn-primary {
  margin: 15px 0 30px 0;
  text-transform: uppercase;
  float: right;
}
.btn-outline-dark {
  margin: 15px 0 30px 0;
  text-transform: uppercase;
  float: left;
}
.required {
  color: #dc3545;
}
#specs {
  border: dashed 2px #5dad0f;
  background: #fff;
  padding: 15px 0;
}
#specs ul {
  margin-bottom: 0;
}
#specs li:last-child {
  margin-bottom: 0;
}
#ml {
  text-align: center;
  margin-top: 20px;
}
#ml a {
  color: #5dad0f;
}
#print .btn-dark {
  width: 175px;
  margin: 30px auto 0;
  display: block;
}
@media print {
  #logo {
    display: block !important;
  }
  #logo img {
    margin: 30px auto 60px;
    display: block;
  }
  #specs {
    display: block !important;
    margin-bottom: 60px;
  }
  #ml {
    display: block !important;
  }
  form {
    display: none;
  }
  #print {
    display: none;
  }
  .table .thead-light th {
    background-color: #000 !important;
    border-color: #000 !important;
  }
  .table td.headline {
    display: none;
  }
  .btn-primary {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Form.vue